import React, { useEffect, useState } from 'react';
import { Platform, View } from 'react-native';
import { useNativeAnalyticsConsent } from '@/store/nativeAnalyticsConsent';
import { SettingsCardRow } from './SettingsCards';
import SwitchInput from '@/components/Inputs/Switch';
import Text from '@/components/Typography/Text';

export default function UsageAnalyticsSettings() {
  const { allowed, loaded, load, choose } = useNativeAnalyticsConsent();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  useEffect(() => { if (Platform.OS === 'ios') load(); }, [load]);
  if (Platform.OS !== 'ios') return null;
  return <SettingsCardRow title="Share usage analytics"
    subtitle="Optional. Send app interactions, purchase events, account and device identifiers to Gab’s analytics service to help improve the app. This choice applies to this device. Turning it off stops new analytics; your app and purchases keep working.">
    <View style={{ gap: 8 }}>
      <SwitchInput accessibilityLabel="Share usage analytics" value={allowed} disabled={!loaded || busy}
        onValueChange={async value => {
          setBusy(true); setError('');
          try { await choose(value); }
          catch (_) { setError('Unable to save your choice. Analytics are off for this session. Please try again.'); }
          finally { setBusy(false); }
        }} />
      {!!error && <Text size="xs" color="danger" accessibilityRole="alert">{error}</Text>}
    </View>
  </SettingsCardRow>;
}
